import { Link } from "react-router-dom";
import { Phone, CalendarCheck } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS, BUSINESS } from "@/lib/constants";

export default function FAQ() {
  return (
    <div data-testid="faq-page" className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <h1 className="font-heading text-4xl sm:text-5xl font-bold text-black text-center">Frequently Asked Questions</h1>
      <p className="mt-4 text-xl text-gray-700 text-center">Plain-English answers to the questions we hear most often.</p>

      <Accordion type="single" collapsible className="mt-10" data-testid="faq-accordion">
        {FAQS.map((f, i) => (
          <AccordionItem key={i} value={`item-${i}`}>
            <AccordionTrigger className="text-left text-lg sm:text-xl font-semibold text-navy hover:no-underline">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-lg text-gray-800 leading-relaxed">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>

      <div className="mt-12 bg-white border-t border-slate-200 pt-10 text-center">
        <h2 className="font-heading text-2xl sm:text-3xl font-bold text-black">Still have a question?</h2>
        <p className="mt-2 text-lg text-gray-700">Call us — we're happy to help.</p>
        <div className="mt-6 flex flex-col sm:flex-row justify-center gap-3">
          <a href={`tel:${BUSINESS.phoneRaw}`} className="btn-primary" data-testid="faq-call-btn"><Phone className="w-5 h-5" /> Call {BUSINESS.phone}</a>
          <Link to="/consultation" className="btn-primary" data-testid="faq-consult-btn">
            <CalendarCheck className="w-5 h-5" /> Book Free Consultation
          </Link>
        </div>
      </div>
    </div>
  );
}
